// ============================================================================
// CHINESE SIMPLIFIED TRANSLATIONS - CHAPTER 3: 耶稣基督
// ============================================================================
// 级别 27-39 (13 级别, 39 问题)

export const chapter3Translations = {
  name: '耶稣基督',
  description: '道成了肉身... 认识基督就是永生',
  
  spiritualWisdom: {
    principle: '认识耶稣基督就是永生',
    scripture: '认识你独一的真神,并且认识你所差来的耶稣基督,这就是永生 (约翰福音17:3)',
    application: '耶稣生命的每一方面都显明神,并为永恒滋养我们的灵魂'
  },
  
  levels: {
    27: {
      name: '天使报喜',
      challenge: '天使加百列奉神的差遣往加利利的一座城去...',
      easy: {
        question: '哪位天使向马利亚报告她将生下耶稣?',
        options: ['米迦勒', '加百列', '拉斐尔', '乌列'],
        hint: '神的使者天使',
        funFact: '👼 加百列意为神的大能 - 伟大宣告的天使!'
      },
      medium: {
        question: '马利亚对这个宣告的第一反应是什么?',
        options: [
          '立刻喜悦',
          '完全不信',
          '困惑并问我没有出嫁,怎么有这事呢?',
          '恐惧'
        ],
        hint: '一个实际而合理的问题',
        funFact: '🤔 马利亚提出合理的问题,但对神保持开放的心!'
      },
      hard: {
        question: '马利亚顺服神旨意教导我们什么?',
        options: [
          '在试炼面前被动',
          '即使不完全明白也信靠的信心',
          '盲目的顺服',
          '听天由命'
        ],
        hint: '是关于即使在未知中也信靠神',
        funFact: '🙏 我是主的使女,情愿照你的话成就在我身上 - 信靠信心的榜样!'
      }
    },
    
    28: {
      name: '降生',
      challenge: '就生了头胎的儿子,用布包起来,放在马槽里...',
      easy: {
        question: '耶稣在哪座城降生?',
        options: ['拿撒勒', '耶路撒冷', '伯利恒', '迦百农'],
        hint: '大卫的城',
        funFact: '🏘️ 伯利恒意为粮仓 - 耶稣,生命的粮!'
      },
      medium: {
        question: '谁最先得到降生的消息?',
        options: [
          '博士',
          '野地里的牧羊人',
          '圣殿的祭司',
          '马利亚的家人'
        ],
        hint: '看守羊群的普通人',
        funFact: '🐑 神首先向谦卑的牧羊人宣告 - 给所有人的福音!'
      },
      hard: {
        question: '耶稣降生在马槽里象征什么?',
        options: [
          '他父母的贫穷',
          '神屈尊就卑来到我们中间的谦卑',
          '缺少地方',
          '乡村的简朴'
        ],
        hint: '是关于谦卑中的神圣道成肉身',
        funFact: '👶 宇宙的创造者降生在马棚里 - 无限的爱!'
      }
    },

    29: {
      name: '东方博士',
      challenge: '有几个博士从东方来到耶路撒冷,说...',
      easy: {
        question: '什么引导博士们找到耶稣?',
        options: ['天使', '星星', '异象', '地图'],
        hint: '天空中的天体',
        funFact: '⭐ 星象征耶稣是万国之光!'
      },
      medium: {
        question: '博士们献上了什么礼物?',
        options: [
          '食物',
          '黄金、乳香和没药',
          '贵重的衣服',
          '玩具'
        ],
        hint: '三件象征性和珍贵的礼物',
        funFact: '🎁 黄金(君王)、乳香(神性)、没药(牺牲) - 耶稣的全部使命!'
      },
      hard: {
        question: '这些外邦博士在神的计划中代表什么?',
        options: [
          '其他宗教的优越性',
          '救恩向所有民族开放的普世性',
          '物质财富',
          '古代科学'
        ],
        hint: '是关于救恩向所有国家开放',
        funFact: '🌍 博士预表将传遍全世界的福音!'
      }
    },

    30: {
      name: '耶稣受洗',
      challenge: '耶稣受了洗,随即从水里上来...',
      easy: {
        question: '谁为耶稣施洗?',
        options: ['彼得', '施洗约翰', '安得烈', '雅各'],
        hint: '耶稣的先锋',
        funFact: '🌊 施洗约翰认为自己不配给耶稣解鞋带!'
      },
      medium: {
        question: '耶稣受洗时什么降在他身上?',
        options: [
          '光',
          '鸽子(圣灵)',
          '天使',
          '只有声音'
        ],
        hint: '和平的象征鸟',
        funFact: '🕊️ 鸽子显明开始事工的神圣膏抹!'
      },
      hard: {
        question: '无罪的耶稣为什么要受洗?',
        options: [
          '为了作榜样',
          '为了尽诸般的义并与我们认同',
          '因为宗教义务',
          '为了得赦免'
        ],
        hint: '是关于与有罪人类的团结',
        funFact: '❤️ 耶稣完全认同我们,为了更好地拯救我们!'
      }
    },

    31: {
      name: '旷野受试探',
      challenge: '耶稣被圣灵引到旷野,受魔鬼的试探...',
      easy: {
        question: '耶稣在旷野禁食了多久?',
        options: ['30天', '40天', '50天', '60天'],
        hint: '圣经中试炼的数字',
        funFact: '🏜️ 像摩西和以利亚一样,40天密集的属灵预备!'
      },
      medium: {
        question: '耶稣如何拒绝每个试探?',
        options: [
          '靠自己的力量',
          '引用圣经',
          '无视撒但',
          '只是祷告'
        ],
        hint: '卓越的属灵武器',
        funFact: '📖 经上记着说... - 神的话,圣灵的宝剑!'
      },
      hard: {
        question: '耶稣受试探教导我们什么关于我们的争战?',
        options: [
          '试探就是罪',
          '试探可以通过神的话和信心得胜',
          '必须逃避一切旷野',
          '只有耶稣能抵挡'
        ],
        hint: '是关于我们对抗试探的策略',
        funFact: '⚔️ 耶稣向我们展示如何得胜:神的话 + 积极的信心!'
      }
    },

    32: {
      name: '首批门徒',
      challenge: '耶稣对他们说:来跟从我,我要叫你们得人如得鱼一样...',
      easy: {
        question: '彼得和安得烈的职业是什么?',
        options: ['牧羊人', '渔夫', '木匠', '税吏'],
        hint: '加利利海上的职业',
        funFact: '🎣 耶稣将捕鱼的渔夫变成得人的渔夫!'
      },
      medium: {
        question: '首批门徒如何回应呼召?',
        options: [
          '犹豫了很久',
          '要求证据',
          '立刻舍下所有跟从他',
          '讨价还价'
        ],
        hint: '立即和完全的回应',
        funFact: '🚶 耶稣的权柄如此明显,他们立刻顺服!'
      },
      hard: {
        question: '在我们这个时代跟从耶稣意味着什么?',
        options: [
          '放弃工作',
          '按照他的教导和旨意生活',
          '加入隔绝的社区',
          '只做传教'
        ],
        hint: '是关于生命和优先次序的转变',
        funFact: '✨ 跟从耶稣转变我们的心、选择、命运!'
      }
    },

    33: {
      name: '登山宝训',
      challenge: '虚心的人有福了，因为天国是他们的...',
      easy: {
        question: '登山宝训中第一个福是什么？',
        options: [
          '清心的人有福了',
          '虚心的人有福了',
          '温柔的人有福了',
          '使人和睦的人有福了'
        ],
        hint: '与属灵谦卑有关',
        funFact: '😊 虚心的人知道他们需要神 - 天国的门户！'
      },
      medium: {
        question: '耶稣对使人和睦的人说了什么？',
        options: [
          '他们将会幸运',
          '他们必称为神的儿子',
          '他们会被爱',
          '他们会强大'
        ],
        hint: '一个特殊的神圣身份',
        funFact: '👑 使人和睦的人像神 - 祂本性的活见证！'
      },
      hard: {
        question: '八福如何颠覆世界的价值观？',
        options: [
          '通过谴责财富',
          '通过隔离信徒',
          '通过宣告世界鄙视的人有福',
          '通过废除律法'
        ],
        hint: '这是关于与世俗价值观相反的神圣价值观',
        funFact: '🔄 八福改变我们对幸福和成功的看法！'
      }
    },

    34: {
      name: '天国的比喻',
      challenge: '他用比喻对他们讲许多道理...',
      easy: {
        question: '在撒种的比喻中，种子代表什么？',
        options: [
          '金钱',
          '神的道',
          '善行',
          '爱'
        ],
        hint: '耶稣宣讲和教导的',
        funFact: '🌱 神的道在我们心中发芽生长！'
      },
      medium: {
        question: '在芥菜种的比喻中，这粒小种子象征什么？',
        options: [
          '人的软弱',
          '从小开始但变得伟大的天国',
          '细节的重要性',
          '自然'
        ],
        hint: '以惊人的方式成长的东西',
        funFact: '🌳 从最小的种子长出大树 - 天国的力量！'
      },
      hard: {
        question: '耶稣为什么用比喻教导？',
        options: [
          '为了使祂的信息复杂化',
          '为了通过熟悉的画面揭示属灵真理',
          '因为时间不够',
          '为了测试智力'
        ],
        hint: '这是关于使天国的奥秘变得可理解',
        funFact: '💡 比喻向敞开的心显明，向封闭的心隐藏！'
      }
    },

    35: {
      name: '耶稣的神迹',
      challenge: '他平静了风暴，对海说：住了吧！静了吧！...',
      easy: {
        question: '耶稣用几个饼喂饱了5000人？',
        options: ['3个饼', '5个饼', '7个饼', '12个饼'],
        hint: '与鱼的数量相同',
        funFact: '🍞 5个饼2条鱼变成盛宴 - 神圣的慷慨！'
      },
      medium: {
        question: '当耶稣平静风暴时，门徒说了什么？',
        options: [
          '他是魔术师',
          '这是谁，连风和海都听从他？',
          '这很正常',
          '我们应该离开这里'
        ],
        hint: '关于耶稣身份的问题',
        funFact: '⛈️ 连自然元素都认识它们的创造主和主！'
      },
      hard: {
        question: '耶稣神迹的主要目的是什么？',
        options: [
          '给众人留下深刻印象',
          '显明祂的神性并彰显神的爱',
          '获得影响力',
          '仅在物质上帮助'
        ],
        hint: '这是关于神圣启示和怜悯',
        funFact: '❤️ 每个神迹都显明神的心：爱、怜悯、大能！'
      }
    },

    36: {
      name: '登山变像',
      challenge: '他在他们面前变了形像，脸面明亮如日头...',
      easy: {
        question: '哪些门徒看见了耶稣变像？',
        options: [
          '全部十二个',
          '彼得、雅各和约翰',
          '只有彼得和约翰',
          '跟随他的妇女们'
        ],
        hint: '三人的核心圈子',
        funFact: '⛰️ 彼得、雅各和约翰：神圣荣耀的特权见证人！'
      },
      medium: {
        question: '旧约中哪些人物出现了？',
        options: [
          '亚伯拉罕和以撒',
          '大卫和所罗门',
          '摩西和以利亚',
          '亚当和挪亚'
        ],
        hint: '律法的代表和先知的代表',
        funFact: '📜 摩西（律法）和以利亚（先知）为耶稣作见证！'
      },
      hard: {
        question: '这次变像揭示了耶稣本性的什么？',
        options: [
          '他是一位伟大的先知',
          '他隐藏的神性暂时显现',
          '他控制光',
          '他能改变外貌'
        ],
        hint: '这是关于揭示祂的神性本质',
        funFact: '✨ 耶稣的神圣荣耀闪耀 - 预示祂的复活！'
      }
    },

    37: {
      name: '荣入圣城',
      challenge: '和散那归于大卫的子孙！奉主名来的是应当称颂的！...',
      easy: {
        question: '耶稣骑什么动物进入耶路撒冷？',
        options: ['马', '驴', '骆驼', '步行'],
        hint: '象征谦卑与和平的动物',
        funFact: '🐴 驴象征谦卑的君王以和平而非战争来临！'
      },
      medium: {
        question: '迎接耶稣的群众喊什么？',
        options: [
          '国王万岁！',
          '和散那！奉主名来的是应当称颂的！',
          '荣耀归于神！',
          '自由！'
        ],
        hint: '喜乐和祝福的呼喊',
        funFact: '🌿 "和散那"意思是"现在拯救" - 呼求神圣拯救！'
      },
      hard: {
        question: '为什么这次入城是"荣耀的"却又是悲剧的？',
        options: [
          '人很少',
          '欢迎他的群众5天后会拒绝他',
          '当局不在',
          '下雨了'
        ],
        hint: '这是关于人心的善变',
        funFact: '💔 同样的群众几天后会喊"钉他十字架！"'
      }
    },

    38: {
      name: '最后的晚餐',
      challenge: '你们拿着吃，这是我的身体，为你们舍的...',
      easy: {
        question: '耶稣对门徒的脚做了什么？',
        options: [
          '祝福它们',
          '洗它们',
          '给它们涂香膏',
          '亲吻它们'
        ],
        hint: '谦卑和服侍的行为',
        funFact: '🦶 老师成为仆人 - 爱与谦卑的革命！'
      },
      medium: {
        question: '耶稣在这次晚餐中设立了什么？',
        options: [
          '洗礼',
          '圣餐',
          '主祷文',
          '禁食'
        ],
        hint: '用饼和酒的圣礼',
        funFact: '🍞🍷 饼和酒成为牺牲和爱的永恒象征！'
      },
      hard: {
        question: '"你们应当如此行，为的是记念我"是什么意思？',
        options: [
          '重复这顿晚餐',
          '庆祝我的死和复活直到我再来',
          '记住我的话',
          '彼此相爱'
        ],
        hint: '这是关于活泼的预言性记念',
        funFact: '⏳ 每次圣餐都宣告主的死，直等到祂来！'
      }
    },

    39: {
      name: '客西马尼园',
      challenge: '我父啊，倘若可行，求你叫这杯离开我...',
      easy: {
        question: '耶稣在被捕前在哪里祷告？',
        options: [
          '在圣殿里',
          '在客西马尼园',
          '在橄榄山上',
          '在朋友家'
        ],
        hint: '橄榄树的园子',
        funFact: '🫒 客西马尼意思是"榨油坊" - 极度压力之地！'
      },
      medium: {
        question: '耶稣祷告时门徒做了什么？',
        options: [
          '与他一起祷告',
          '睡着了',
          '站岗',
          '离开了'
        ],
        hint: '连一个小时都不能警醒',
        funFact: '😴 心灵固然愿意，肉体却软弱了 - 人的软弱！'
      },
      hard: {
        question: '耶稣的痛苦揭示了祂本性的什么？',
        options: [
          '他只是人',
          '他是完全的人也是完全的神',
          '他怀疑自己的使命',
          '他软弱'
        ],
        hint: '这是关于道成肉身的奥秘',
        funFact: '✝️ 耶稣完全承担人的痛苦，同时对神保持忠诚！'
      }
    }
  }
};

export default chapter3Translations;
